import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import AlertsService from 'cio/services/alerts';

import { ApiResponse, ApiError } from 'cio/services/api';
import RouterService from '@ember/routing/router-service';
import AuthService from 'cio/services/auth';
import { Authenticated2faSetupRouteModel } from 'cio/pods/authenticated/2fa-setup/route';

export default class Authenticated2faSetupNewTotp extends Controller {
  @service alerts!: AlertsService;
  @service router!: RouterService;
  @service auth!: AuthService;

  declare model: Pick<Authenticated2faSetupRouteModel, 'user' | 'secret'>;

  serverErrors!: string[];

  _canFinish = false;

  @action
  setupTwoFactorAuthentication(code: string) {
    return this.model.user
      .setupTwoFactorAuthentication({ code, secret: this.model.secret })
      .then(() => this.model.user.reload()) // refresh current user to reflect new 2FA status
      .then(() => {
        this.alerts.success('user.twoAuthConfirmBackupCodes.success', 'Two-factor authentication is now enabled.');
        return this.router.transitionTo('authenticated');
      })
      .catch((err: ApiResponse | any) => {
        if (err.errors && (err.errors as ApiError[])[0] && (err.errors as ApiError[])[0].status === '400') {
          return this.set('serverErrors', ['Your authentication code is invalid. Try again?']);
        }

        // don't re-throw a transition aborted error due to an internal redirect from "app.index" route:
        if (err.message === 'TransitionAborted') {
          return;
        }

        throw err;
      });
  }

  @action
  resetServerErrors() {
    this.set('serverErrors', []);
  }

  @action
  back() {
    this.router.transitionTo('authenticated.2fa_setup.index');
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'authenticated/2fa-setup/new-totp': Authenticated2faSetupNewTotp;
  }
}
